//CRN_20260825 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';
import { SimStatusDisplay, SimStatusDisplay_EmptyObject } from 'src/app/core/interfaces/general/sim-status-display';

@Injectable({ providedIn: 'root' })

export class SimStatusService {

  private readonly icons: { [statusIcon: string]: { colourClass: string, iconClass: string } } = {
    AlertProductChanged: { colourClass: "text-warning", iconClass: "bx bx-transfer"             },
    AlertThrottled     : { colourClass: "text-warning", iconClass: "bx ri-slow-down-line"       },
    AwaitingDeployment : { colourClass: "text-warning", iconClass: "bx bx-hourglass"            },
    AwaitingDownload   : { colourClass: "text-warning", iconClass: "bx bx-hourglass"            },
    Barred             : { colourClass: "text-warning", iconClass: "bx bxs-lock-alt"            },
    Ceased             : { colourClass: "text-danger",  iconClass: "bx bx-x"                    },
    Downloaded         : { colourClass: "text-info",    iconClass: "bx bx-download"             },
    Removed            : { colourClass: "text-muted",   iconClass: "bx bx-trash"                },
    Sent               : { colourClass: "text-info",    iconClass: "bx bx-message-rounded-dots" },
    Suspended          : { colourClass: "text-danger",  iconClass: "bx bx-block"                },
    SwitchedOff        : { colourClass: "text-primary", iconClass: "bx bx-pause-circle"         },
    SwitchedOn         : { colourClass: "text-success", iconClass: "bx bxs-circle"              },
  };

  private readonly statusFallbacks: { [status: string]: { statusDisplay: string, statusIcon: string } } = {
    "Awaiting Deployment"     : { statusDisplay: "Awaiting Deployment",       statusIcon: "AwaitingDeployment"  },
    "Awaiting Download"       : { statusDisplay: "Awaiting Download",         statusIcon: "AwaitingDownload"    },
    "Ceased"                  : { statusDisplay: "Ceased",                    statusIcon: "Ceased"              },
    "Disabled"                : { statusDisplay: "Switched Off",              statusIcon: "SwitchedOff"         },
    "Downloaded"              : { statusDisplay: "Downloaded",                statusIcon: "Downloaded"          },
    "Live"                    : { statusDisplay: "Switched On",               statusIcon: "SwitchedOn"          },
    "Live - Alert Product"    : { statusDisplay: "Alert - Product Changed",   statusIcon: "AlertProductChanged" },
    "Live - Barred"           : { statusDisplay: "Barred",                    statusIcon: "Barred"              },
    "Live - Suspended"        : { statusDisplay: "Suspended",                 statusIcon: "Suspended"           },
    "Live - Throttled 512Kbps": { statusDisplay: "Alert - Throttled 512Kbps", statusIcon: "AlertThrottled"      },
    "Live - Throttled 64Kbps" : { statusDisplay: "Alert - Throttled 64Kbps",  statusIcon: "AlertThrottled"      },
    "Removed"                 : { statusDisplay: "Removed from Device",       statusIcon: "Removed"             },
    "Sent - SMS/email"        : { statusDisplay: "Sent via SMS/Email",        statusIcon: "Sent"                },
  };

  constructor(
    private exceptionsService: ExceptionsService
  ) { }

  public getDisplay(status: string | undefined, statusDisplay?: string, statusIcon?: string): SimStatusDisplay {
    try {
      const rawStatus=(status ?? "").trim();
      const fallback =this.statusFallbacks[rawStatus];
      const display  =(statusDisplay ?? "").trim()==="" ? (fallback?.statusDisplay ?? rawStatus) : <string>statusDisplay;
      const iconKey  =(statusIcon    ?? "").trim()==="" ? (fallback?.statusIcon    ?? ""       ) : <string>statusIcon;
      const icon     =this.icons[iconKey];

      return {
        colourClass  : icon?.colourClass ?? "",
        iconClass    : icon?.iconClass   ?? "",
        status       : rawStatus,
        statusDisplay: display,
        statusIcon   : iconKey,
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return SimStatusDisplay_EmptyObject();
    }
  }

  public getDisplayForRow(row: any): SimStatusDisplay {
    try {
      return this.getDisplay(row?.status, row?.statusDisplay, row?.statusIcon);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return SimStatusDisplay_EmptyObject();
    }
  }

  public getIcon(row: any): SimStatusDisplay | undefined {
    try {
      const simStatus=this.getDisplayForRow(row);

      return simStatus.iconClass=="" ? undefined : simStatus;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public toStatusDisplays(statuses: string[]): string[] {
    try {
      return statuses.map(x => this.getDisplay(x).statusDisplay);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }
}
